import { Text, Button } from '@/components'
import { AlertMessage } from 'app-components'
import { ButtonContainer } from '@/app/pages/ava/BrandedPage'

interface KeyNotAttachedViewProps {
  onConfirmClick: () => void
  isLoading: boolean
}

export default function KeyNotAttachedView({
  onConfirmClick,
  isLoading,
}: KeyNotAttachedViewProps) {
  return (
    <>
      <Text variant="h2" className="!mt-16">
        We Didn't Detect Your Virtual Key
      </Text>
      <div className="flex flex-col gap-4 !mt-4">
        <Text variant="body2">
          We weren’t able to complete your connection test because Optiwatt
          isn’t able to connect to your car.
        </Text>
        <AlertMessage show={true} variant="error">
          Connect your virtual key and try again.
        </AlertMessage>
      </div>
      <ButtonContainer>
        <Button
          id="tesla-fleet-auth-survey-retry-key-button"
          variant="primary"
          disabled={isLoading}
          onClick={onConfirmClick}
        >
          Connect Virtual Key
        </Button>
      </ButtonContainer>
    </>
  )
}
